import _ from 'lodash';
import angular from 'angular';
import template from './minMaxCriteriaView.html';
import searchItemsPriority, { preferredPrioritySupportCriterias } from '../../constants/searchItemsPriority';
import { isEmptyCriteria } from '../../services/searchCriteriaUtils';

export const SeniorityType = {
    any: 'any',
    same: 'same',
};

export class MinMaxCriteriaComponent {
    /* @ngInject */
    constructor(staticDataService, searchCacheService, $scope) {
        this.$scope = $scope;
        this.$scope.searchItemsPriority = searchItemsPriority;
        this.$scope.preferredPrioritySupportCriterias = preferredPrioritySupportCriterias;

        const ctrl = this;
        ctrl.init = function () {
            ctrl.mandatoryValues = [
                {
                    value: 'optional',
                    text: 'NORMAL',
                },
                {
                    value: 'preferred',
                    text: 'PREFERRED_PRIORITY_LABEL',
                },
                {
                    value: 'mandatory',
                    text: 'MANDATORY_MINUS',
                },
                {
                    value: 'filter',
                    text: 'MANDATORY',
                },
            ];
            ctrl.seniorityTypeDropdownOptions = [{
                value: SeniorityType.any,
                label: 'SENIORITY_TYPE_OPTIONS_ANY',
                text: 'SENIORITY_TYPE_OPTIONS_ANY',
            }, {
                value: SeniorityType.same,
                label: 'SENIORITY_TYPE_OPTIONS_SAME',
                text: 'SENIORITY_TYPE_OPTIONS_SAME',
            }];
        };

        ctrl.setupShow = function () {
            if (ctrl.data.minSelected.length <= 0 && ctrl.data.maxSelected.length <= 0) {
                ctrl.showAdd = true;
            } else if (ctrl.data.minSelected.length > 0 || ctrl.data.maxSelected.length > 0) {
                ctrl.showAdd = false;
            }
        };

        ctrl.setupMinValues = function () {
            // setup min values
            for (let i = 0; i < ctrl.data.minSelected.length; i++) {
                if (ctrl.data.minSelected[i].required == true) {
                    ctrl.data.minSelected[i].required = 'mandatory';
                } else if (!ctrl.data.minSelected[i].required) {
                    ctrl.data.minSelected[i].required = 'optional';
                } else if (ctrl.data.minSelected[i].required === 0 || ctrl.data.minSelected[i].required === false) {
                    ctrl.data.minSelected[i].required = 'optional';
                }
                const minIndex = _.findIndex(ctrl.mandatoryValues, { value: ctrl.data.minSelected[i].required });
                if (minIndex >= 0) {
                    ctrl.minRequiredIndexes.push({
                        requiredValue: minIndex,
                    });
                } else {
                    ctrl.minRequiredIndexes.push({
                        requiredValue: 0,
                    });
                }
            }
        };

        ctrl.setupMaxValues = function () {
            // setup maxValues
            for (let i = 0; i < ctrl.data.maxSelected.length; i++) {
                if (ctrl.data.maxSelected[i].required === true) {
                    ctrl.data.maxSelected[i].required = 'mandatory';
                } else if (!ctrl.data.maxSelected[i].required) {
                    ctrl.data.maxSelected[i].required = 'optional';
                } else if (ctrl.data.maxSelected[i].required === 0 || ctrl.data.maxSelected[i].required === false) {
                    ctrl.data.maxSelected[i].required = 'optional';
                }
                const maxIndex = _.findIndex(ctrl.mandatoryValues, { value: ctrl.data.maxSelected[i].required });
                if (maxIndex >= 0) {
                    ctrl.maxRequiredIndexes.push({
                        requiredValue: maxIndex,
                    });
                } else {
                    ctrl.maxRequiredIndexes.push({
                        requiredValue: 0,
                    });
                }
            }
        };

        ctrl.initData = function () {
            ctrl.editMode = false;

            ctrl.setupShow();

            ctrl.showMinDropDown = false;
            ctrl.showMaxDropDown = false;
            ctrl.mandatoryMinPopUpView = -1;
            ctrl.mandatoryMaxPopUpView = -1;
            ctrl.minRequiredIndexes = [];
            ctrl.maxRequiredIndexes = [];

            ctrl.setupMaxValues();
            ctrl.setupMinValues();
            ctrl.getStaticData();
            ctrl.setupSeniorityType();

            ctrl.minHasPreferred = preferredPrioritySupportCriterias.includes(ctrl.data && ctrl.data.minField);
            ctrl.maxHasPreferred = preferredPrioritySupportCriterias.includes(ctrl.data && ctrl.data.maxField);
        };

        ctrl.getStaticData = function () {
            staticDataService.getStaticData(ctrl.data.lookupData, (data) => {
                ctrl.staticData = angular.copy(data);
                ctrl.filteredStaticData = ctrl.staticData;

                if (ctrl.data.minSelected.length > 0) {
                    const [minSelected] = ctrl.data.minSelected;
                    const { uid } = minSelected;
                    const minIndex = _.findIndex(ctrl.filteredStaticData, { id: uid.toString() });
                    if (minIndex >= 0) {
                        ctrl.minValue = ctrl.filteredStaticData[minIndex];
                        if (!minSelected.value) {
                            minSelected.value = ctrl.minValue.text;
                        }
                        ctrl.minValueIndex = minIndex;
                    }
                }

                const conditionMin1 = ctrl.data.minSelected.length <= 0;
                const conditionMin2 = ctrl.data.minSelected.length > 0 && !ctrl.data.minSelected[0].uid;
                if (conditionMin1 || conditionMin2) {
                    ctrl.minValueIndex = 0;
                }

                if (ctrl.data.maxSelected.length > 0) {
                    const [maxSelected] = ctrl.data.maxSelected;
                    const { uid } = maxSelected;
                    const maxIndex = _.findIndex(ctrl.filteredStaticData, { id: uid.toString() });
                    if (maxIndex >= 0) {
                        ctrl.maxValue = ctrl.filteredStaticData[maxIndex];
                        if (!maxSelected.value) {
                            maxSelected.value = ctrl.maxValue.text;
                        }
                        ctrl.maxValueIndex = maxIndex;
                    }
                }

                const conditionMax1 = ctrl.data.maxSelected.length <= 0;
                const conditionMax2 = ctrl.data.maxSelected.length > 0 && !ctrl.data.maxSelected[0].uid;

                if (conditionMax1 || conditionMax2) {
                    ctrl.maxValueIndex = ctrl.filteredStaticData.length - 1;
                }
            });
        };

        ctrl.staticChosen = function (value) {
            if (!value) {
                return;
            }
            // minMaxCriteriaCtrl.data.minSelected[0].uid = value.id.toString();
            // minMaxCriteriaCtrl.data.minSelected[0].value = value.text;
            ctrl.showMinDropDown = false;
            ctrl.showMaxDropDown = false;
            ctrl.showAdd = false;
            ctrl.filterValues = '';
            searchCacheService.saveLastSearchField(ctrl.data.field, ctrl.filterValues);
        };

        ctrl.removeMinValue = function (index) {
            ctrl.minRequiredIndexes.splice(index, 1);
            if (ctrl.minValue && ctrl.minValue.id) {
                ctrl.minValue = null;
            }
            ctrl.data.minSelected.splice(index, 1);
        };

        ctrl.removeMaxValue = function (index) {
            ctrl.maxRequiredIndexes.splice(index, 1);
            if (ctrl.maxValue && ctrl.maxValue.id) {
                ctrl.maxValue = null;
            }
            ctrl.data.maxSelected.splice(index, 1);
        };

        ctrl.setRequiredSubCriteria = function (value, isMin) {
            ctrl.mandatoryMinPopUpView = -1;
            ctrl.mandatoryMaxPopUpView = -1;

            if (isMin) {
                ctrl.data.minSelected[0].required = value.required;
            } else {
                ctrl.data.maxSelected[0].required = value.required;
            }

            const [minSelected] = ctrl.data.minSelected;
            let minSelectedRequiredValue = null;
            if (minSelected) {
                minSelectedRequiredValue = minSelected.required;
            }
            const [maxSelected] = ctrl.data.maxSelected;
            let maxSelectedRequiredValue = null;
            if (maxSelected) {
                maxSelectedRequiredValue = maxSelected.required;
            }

            const minIndex = _.findIndex(ctrl.mandatoryValues, { value: minSelectedRequiredValue });
            const maxIndex = _.findIndex(ctrl.mandatoryValues, { value: maxSelectedRequiredValue });
            // min required index starts here
            if (ctrl.minRequiredIndexes.length <= 0) {
                if (minIndex >= 0) {
                    ctrl.minRequiredIndexes.push({
                        requiredValue: minIndex,
                    });
                } else {
                    ctrl.minRequiredIndexes.push({
                        requiredValue: 0,
                    });
                }
            } else if (minIndex >= 0) {
                if (ctrl.minRequiredIndexes[0]) {
                    ctrl.minRequiredIndexes[0].requiredValue = minIndex;
                } else {
                    ctrl.minRequiredIndexes.push({
                        requiredValue: minIndex,
                    });
                }
            } else if (ctrl.minRequiredIndexes[0]) {
                ctrl.minRequiredIndexes[0].requiredValue = 0;
            } else {
                ctrl.minRequiredIndexes.push({
                    requiredValue: minIndex,
                });
            }
            // min required index ends here

            // max required index starts here
            if (ctrl.maxRequiredIndexes.length <= 0) {
                if (maxIndex >= 0) {
                    ctrl.maxRequiredIndexes.push({
                        requiredValue: maxIndex,
                    });
                } else {
                    ctrl.maxRequiredIndexes.push({
                        requiredValue: 0,
                    });
                }
            } else if (maxIndex >= 0) {
                if (ctrl.maxRequiredIndexes[0]) {
                    ctrl.maxRequiredIndexes[0].requiredValue = maxIndex;
                } else {
                    ctrl.maxRequiredIndexes.push({
                        requiredValue: maxIndex,
                    });
                }
            } else if (ctrl.minRequiredIndexes[0]) {
                ctrl.minRequiredIndexes[0].requiredValue = 0;
            } else {
                ctrl.minRequiredIndexes.push({
                    requiredValue: maxIndex,
                });
            }
            // max required index ends here
        };

        ctrl.setRequiredSubCriteriaMin = function (index, value) {
            ctrl.setRequiredSubCriteria(value, true);
        };

        ctrl.setRequiredSubCriteriaMax = function (index, value) {
            ctrl.setRequiredSubCriteria(value, false);
        };

        ctrl.submitCriteria = function () {
            if (ctrl.editMode) {
                const condition1 = !(((ctrl.data.minSelected.length > 0
                    || ctrl.data.maxSelected.length > 0)
                    && !ctrl.showAdd && ctrl.editMode)
                    || ((ctrl.data.minSelected.length <= 0
                        && ctrl.data.maxSelected.length <= 0)
                        && !ctrl.showAdd));

                const condition2 = ((ctrl.data.minSelected.length <= 0
                    && ctrl.data.maxSelected.length <= 0)
                    && !ctrl.showAdd);

                if (condition1 && condition2) {
                    ctrl.minValue = null;
                    ctrl.maxValue = null;
                    ctrl.showAdd = true;
                    return;
                }
                const condition3 = (!ctrl.minValue || !ctrl.minValue.id) && (!ctrl.maxValue || !ctrl.maxValue.id);

                if (condition3) {
                    ctrl.minValueIndex = 0;
                    ctrl.maxValueIndex = ctrl.filteredStaticData.length - 1;
                    return;
                }

                ctrl.editMode = false;
                // call API
                if (ctrl.minValue && ctrl.minValue.id) {
                    let requiredValue = 0;
                    if (ctrl.minRequiredIndexes.length > 0) {
                        [{ requiredValue = 0 }] = ctrl.minRequiredIndexes;
                    }
                    const required = ctrl.mandatoryValues[requiredValue].value;
                    const minSelected = {
                        uid: ctrl.minValue.id.toString(),
                        value: ctrl.minValue.text,
                        required,
                    };
                    ctrl.data.minSelected = [minSelected];
                } else if (ctrl.data.minSelected.length > 0) {
                    ctrl.data.minSelected = [];
                }

                if (ctrl.maxValue && ctrl.maxValue.id) {
                    let requiredValue = 0;
                    if (ctrl.maxRequiredIndexes.length > 0) {
                        [{ requiredValue = 0 }] = ctrl.maxRequiredIndexes;
                    }
                    const required = ctrl.mandatoryValues[requiredValue].value;
                    const maxSelected = {
                        uid: ctrl.maxValue.id.toString(),
                        value: ctrl.maxValue.text,
                        required,
                    };
                    ctrl.data.maxSelected = [maxSelected];
                } else if (ctrl.data.maxSelected.length > 0) {
                    ctrl.data.maxSelected = [];
                }

                if ((!ctrl.minValue || ctrl.minValue.text === 'NOT_IMPORTANT')
                    && (!ctrl.maxValue || ctrl.maxValue.text === 'NOT_IMPORTANT')) {
                    ctrl.showAdd = true;
                }
            }
        };

        ctrl.setMinPopupView = function (value) {
            if (value !== -1) {
                ctrl.mandatoryMaxPopUpView = -1;
            }

            ctrl.mandatoryMinPopUpView = value;
        };

        ctrl.setMaxPopupView = function (value) {
            if (value !== -1) {
                ctrl.mandatoryMinPopUpView = -1;
            }

            ctrl.mandatoryMaxPopUpView = value;
        };

        ctrl.setupSeniorityType = () => {
            ctrl.showSeniorityTypeDropdown = _.get(ctrl, 'data.customType') === 'relevantYearsExperience';

            if (ctrl.showSeniorityTypeDropdown) {
                const minSameCriteria = { items: _.get(ctrl, 'data.minSameSelected') };
                const maxSameCriteria = { items: _.get(ctrl, 'data.maxSameSelected') };
                const isSameSeniority = !isEmptyCriteria(minSameCriteria) || !isEmptyCriteria(maxSameCriteria);

                if (isSameSeniority) {
                    ctrl.seniorityType = SeniorityType.same;
                } else {
                    ctrl.seniorityType = SeniorityType.any;
                }
            }
        };

        ctrl.setSeniorityType = ({ value: newSeniorityType }) => {
            ctrl.seniorityType = newSeniorityType;

            if (newSeniorityType === SeniorityType.any) {
                ctrl.data.minField = ctrl.data.minAnyField;
                ctrl.data.maxField = ctrl.data.maxAnyField;
            } else {
                ctrl.data.minField = ctrl.data.minSameField;
                ctrl.data.maxField = ctrl.data.maxSameField;
            }
        };

        ctrl.init();
    }
}

export const MinMaxCriteriaComponentConfiguration = {
    bindings: {
        data: '=',
        lastSearch: '=',
        allData: '=',
        disable: '=',
    },
    template,
    controller: MinMaxCriteriaComponent,
    controllerAs: 'minMaxCriteriaCtrl',
};

angular
    .module('TALENYA-FE')
    .component('minMaxCriteriaComponent', MinMaxCriteriaComponentConfiguration);
